import isTouchDevice from '../utils/is-touch-device'

if (isTouchDevice()) {
  document.documentElement.className += ' touch';
} else {
  document.documentElement.className += ' no-touch';
}
